import { Affix, Col, Hidden, Row, Section, Wrapper } from '@ahmdigital/ui';
import { ComponentProps, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

const StyledCol = styled(Col)`
  padding-bottom: 1.25rem;
  padding-top: 1.25rem;
`;

type InsuranceSectionProps = PropsWithChildren<{
  dfContentCols?: number;
  sidebar?: ReactNode;
}> &
  ComponentProps<typeof Section>;

const InsuranceSection = ({ children, dfContentCols = 8, sidebar = null, ...props }: InsuranceSectionProps) => (
  <Section {...props}>
    <Wrapper>
      <Row>
        <StyledCol df={dfContentCols} sm={12}>
          {children}
        </StyledCol>
        {sidebar && (
          <StyledCol df={4} sm={12}>
            <Hidden xs sm>
              <Affix viewportOffsetTop="100">{sidebar}</Affix>
            </Hidden>
            <Hidden md lg df>
              {sidebar}
            </Hidden>
          </StyledCol>
        )}
      </Row>
    </Wrapper>
  </Section>
);

export default InsuranceSection;
